import React from "react";
import { Link } from "react-router-dom";
import { Container, Card, UncontrolledTooltip  } from "reactstrap";
import TableComponent from "../../../components/Common/TableComponent";
import { getQuestionList } from "../../../services/questionService";
import { notifyError } from "../../../utils/utils";
import PaginationComponent from "../../../components/Common/Pagination";
import moment from "moment";


class QuestionList extends React.Component {

    constructor(props){
        super(props);

        this.state = {
            page: 0,
            sort: "question_id",
            limit: 10,
            asc: false,
            created_by:"",
            questions:[],
            total_count: 0,
            user:"",
            loading: false
        };

        this.changePage = this.changePage.bind(this);
    }

    
    changePage(pageNumber) {

        this.setState({ page: pageNumber });

        const req = {
            offset: pageNumber,
            limit: this.state.limit,
            created_by: this.state.created_by,
            sort: this.state.sort,
            asc: this.state.asc
        };
        this.setState({ loading: true });
        getQuestionList(req)
        .then(response => {
            this.setState({ loading: false });
            const { data } = response;
            if(data.status)
            {
                this.setState({
                    questions: data.questions,
                    total_count: data.totalCount
                });

                if(this.state.created_by)
                    this.setState({user: data.user_data});
            } else {
                notifyError(data.message);
                this.setState({
                    questions: [],
                    total_count: 0
                });
            }

        })
    }

    componentDidMount() {
        if(this.props.match.params.userid) {
            this.setState({
                created_by: this.props.match.params.userid
            }, () => this.changePage(0));
        } else {
            this.changePage(0);
        }
    }
    

    render() {
        
        let columns = [
            {
                Header: () => "Question Id" ,
                accessor: "question_id",
                width: "10%",
                Cell: ({row}) => <span>{row.original.question_id}</span>,
            },
            {
                Header: () => "Question" ,
                accessor: "question",
                width: "30%",
                // sortable : true,
                Cell: ({row}) => <span>{row.original.question}</span>,
            },
            {
                Header: () => "Created Date" ,
                accessor: "createdAt",
                // sortable : true,
                Cell: ({row}) => <span>{moment(row.original.createdAt).format("DD-MM-YYYY")}</span>,
            },
            {
                Header: "Action",
                sortable: false,
                Cell: ({row}) => 
                    <>
                        {
                            this.state.created_by 
                            ?
                                <>
                                    <Link to={`/questions/${row.original.question_id}`} className="mr-3 text-primary" id={`view_${row.original.question_id}`}><i className="mdi mdi-eye font-size-18"></i></Link>
                                    <UncontrolledTooltip placement="top" target={`view_${row.original.question_id}`}>
                                        View Details
                                    </UncontrolledTooltip >        
                                </>
                            :
                                <>
                                    <Link to={`/questions/user/${row.original.created_by}`} className="mr-3 text-primary" id={`view_${row.original.question_id}`}><i className="mdi mdi-eye font-size-18"></i></Link>
                                    <UncontrolledTooltip placement="top" target={`view_${row.original.question_id}`}>
                                        View All Question
                                    </UncontrolledTooltip >        
                                </>
                        }
                    </>
            }
        ];

        if(!this.state.created_by) {
            columns = [
                {
                    Header: () => "User Id" ,
                    accessor: "created_by",
                    // sortable : true,
                    width: "5%",
                    Cell: ({row}) => <span>{row.original.created_by}</span>,
                },
                {
                    Header: "User",
                    accessor: "user.first_name",
                    // sortable: true,
                    Cell: ({row}) => {
                        return (
                            <>
                                <span>{`${row.original["user.first_name"] || "NA"} ${row.original["user.last_name"] || "NA"}`}</span> 
                            </>
                        )
                    }
                },
                ...columns
            ];
        }

        return(
            <React.Fragment>
                 <div className="page-content">

                    <Container fluid>
                            <Card>
                                <h3 className="p-3">
                                   {this.state.created_by && `${this.state.user.first_name} ${this.state.user.last_name}'s`} Question List
                                </h3>
                                <hr />
                            {/* </Card>
                            <Card> */}
                                <div className="table-responsive mt-2 p-1 scrollbar" style={{overflowY:"auto", "height": this.state.total_count > 0 ?  "1000px" : "100px"}}>
                                    <TableComponent
                                        columns={columns}
                                        data={this.state.questions}
                                        loading={this.state.loading}
                                    />
                                </div>
                                <div style={{"position":"absolute","bottom":"10px","width":"100%","zIndex":"99999", backgroundColor: "white"}}>
                                {
                                    this.state.total_count > 0
                                    ?

                                    <PaginationComponent
                                    total_count={this.state.total_count}
                                    page={this.state.page}
                                    limit={this.state.limit}
                                    changePage={this.changePage}
                                    changeFilter={e => {
                                        this.setState({ limit: e.target.value }, () => this.changePage(0));
                                    }}
                                    /> : ""
                                }
                                </div>
                            </Card>
                    </Container>
                </div>
            </React.Fragment>
        )
    }
}

export default QuestionList;